"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlledQuantityPicker = useControlledQuantityPicker;
var _react = require("react");
/**
 * @param {UseQuantityPickerInnerProps} Props
 * @private
 */
function useControlledQuantityPicker(props) {
  const {
    groupValue,
    id,
    log,
    onChange,
    setLastIncreased,
    triggerClickEvent,
    value
  } = props;
  const onIncrease = (0, _react.useCallback)(() => {
    triggerClickEvent(id);
    if (typeof value !== 'number') {
      return;
    }
    setLastIncreased(id);
    log('onIncrease:', value + 1);
    onChange?.(value + 1, id, 'increase');
  }, [id, log, onChange, setLastIncreased, triggerClickEvent, value]);
  const onDecrease = (0, _react.useCallback)(() => {
    triggerClickEvent(id);
    setLastIncreased('');
    if (typeof value !== 'number') {
      return;
    }
    log('onDecrease:', value - 1);
    onChange?.(value - 1, id, 'decrease');
  }, [id, log, onChange, setLastIncreased, triggerClickEvent, value]);
  const handleInputElement = (0, _react.useCallback)((action, inputValue) => {
    const source = action === 'change' ? 'input-change' : 'input-blur';
    log(`on ${source} inputValue is:`, inputValue);
    if (inputValue === '' || inputValue === '-') {
      onChange?.(inputValue, id, source);
      return;
    }
    const num = Number.parseInt(inputValue, 10);
    if (!Number.isNaN(num)) {
      onChange?.(num, id, source);
    }
  }, [id, log, onChange]);
  const handleChange = (0, _react.useCallback)(({
    currentTarget
  }) => {
    triggerClickEvent(id);
    setLastIncreased('');
    handleInputElement('change', currentTarget.value);
  }, [handleInputElement, id, setLastIncreased, triggerClickEvent]);
  const handleBlur = (0, _react.useCallback)(({
    currentTarget
  }) => {
    triggerClickEvent(id);
    setLastIncreased(id);
    handleInputElement('blur', currentTarget.value);
  }, [handleInputElement, id, setLastIncreased, triggerClickEvent]);
  return {
    ...props,
    groupValue: groupValue ?? 0,
    handleBlur,
    handleChange,
    id,
    onDecrease,
    onIncrease,
    value: value
  };
}
//# sourceMappingURL=useControlledQuantityPicker.js.map